import { type DocumentNode, gql } from '@apollo/client';

const allPermissionGroup: DocumentNode = gql`
  query all_permissions_groups($first: Int, $last: Int, $name_Icontains: String) {
    allPermissionGroups(first: $first, last: $last, name_Icontains: $name_Icontains) {
      totalCount
      edges {
        node {
          id
          name
          description
        }
      }
    }
  }
`;

export default allPermissionGroup;
